import { render, staticRenderFns } from "./ArticleMediaNav.vue?vue&type=template&id=51c0d77c&"
import script from "./ArticleMediaNav.vue?vue&type=script&lang=js&"
export * from "./ArticleMediaNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports